/**
 * Created by B032151 on 10/24/2016.
 */
import { ServerActions } from '../../actions/serverActions';
import Constants from '../../constants/constants';
import { dispatcher } from '../../dispatcher/dispatcher';
import { formConversion } from '../../util/formConversion';
import { CurrentSchematic } from '../../actions/compare/currentSchematic';
import { StageSchematic } from '../../actions/compare/stageSchematic';
const { ActionTypes } = Constants;

export const CompareSubDivisionActions = {

    selectChanged: function (selectedSub) {

        dispatcher.dispatch({
            type: ActionTypes.RESET_COMPARE_DETAILS
        });

        var schematicSelected = $('#gisSelect').val();
        dispatcher.dispatch({
            type: ActionTypes.COMPARE_SUBDIVISION_CHANGED,
            selectedSub: selectedSub,
            selectedschematic: schematicSelected
        });

        var subDetailsRequest = ServerActions.getSubdivisionDetailsPromise(selectedSub);

        subDetailsRequest.done(function (data) {
            data = formConversion.convertSubDetailsToSchematicFormat(data);

            CurrentSchematic.subdivisionDetailsLoaded(data);
            StageSchematic.subdivisionDetailsLoaded(data);

            CurrentSchematic.setSubdivision(selectedSub).then(function (response) {
                console.log("Set Sub Prod: ", response);

                StageSchematic.setSubdivision(selectedSub).then(function (response) {
                    console.log("Set Sub Stage: ", response);
                    StageSchematic.centerAndZoom();
                }).catch(function (e) {
                    console.log("Unable to set Sub Stage: ", e);
                });
                CurrentSchematic.centerAndZoom();
            }).catch(function (e) {
                console.log("Unable to set Sub Prod: ", e);
            });

        });
    }
};
